<template>
  <div class="addExtraFee">
    <div class="goods_batch_weight goods_input">
      <span class="good_label">费用名称</span>
      <div class="good_input">
        <input type="text" v-model="subData.name" style="width: 100%;" />
      </div>
    </div>
    <div class="goods_batch_pack">
      <span class="good_label">收费方式</span>
      <div class="good_pack">
        <span
          v-for="(item,index) in pack_list"
          :key="index"
          :class="subData.type == item.value?'active':''"
          @click="subData.type = item.value"
        >{{item.name}}</span>
      </div>
      <div class="good_desc">{{desc_list[subData.type-1].name}}</div>
    </div>
    <div class="goods_batch_num goods_input" v-if="subData.type == 1">
      <span class="good_label">数量</span>
      <div class="good_input">
        <input type="number" v-model="subData.num" :min="1" :step="1" />
        <span>个</span>
      </div>
    </div>
    <div class="goods_batch_weight goods_input">
      <span class="good_label">收费金额</span>
      <div class="good_input">
        <input type="number" v-model="subData.price" :step="0.01" />
        <span>元 {{subData.type == 1?'/ 个':''}}</span>
      </div>
    </div>
    <div class="good_save" @click="save()">确 认</div>
  </div>
</template>

<script>
import { exetaFee_update } from "@/api/work/manage/exetaFee"
export default {
  name: "addExtraFee",
  data() {  
    return {
      radio: "1",
      pack_list: [
        { value: 1, name: "按量收费" },
        { value: 2, name: "按单收费" }
      ],
      unit_list: [
        { value: 1, name: "个" },
        { value: 2, name: "单" }
      ],
      desc_list: [
        { value: 1, name: "按数量收费，如押箱费" },
        { value: 2, name: "按订单收费，每个订单收取一笔" }
      ],
      subData: {
        id: "",
        batch: "", //批次号
        type: "1", //1自营，2代卖
        name: "", //
        unit: 2, //1斤，2公斤。添加时必填 默认为2
        bale: 4, // 销售包装 正装  4前端定义附加费
        num_unit: 1, // 单位
        num: 1, // 数量
        bale_num: 0, // 规格 bale==1 必传
        weight: 0, // 销售重量
        price: 0, // 单价
        goods_type:2
      },
      loading:true
    };
  },
  created() {},
  mounted() {

  },
  methods: {
    
    // 提交数据
    save(){
      if(!this.loading){
        return false
      }
      if(!this.subData.name){ this.$toast("请输入附加费名称！"); return false }
      if(this.subData.type == 1 && !(this.subData.num>0)){ this.$toast("请输入附加费数量！"); return false }

      if(this.subData.type != 1){
        this.subData.num = 1
      }
      var subData = JSON.parse(JSON.stringify(this.subData))
      this.loading = false
      exetaFee_update(subData).then(res=>{
        this.loading = true 
        if(res.code == 200){
          this.$toast.success(res.message);
          this.$router.go(-1)
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.addExtraFee {
  position: relative;
  min-height: calc(100vh - 0.88rem);
  background-color: #fff;
  padding: 0.3rem;
  box-sizing: border-box;
  & > div {
    overflow: hidden;
  }
  .good_label {
    font-size: 0.34rem;
    color: #333;
    line-height: 0.6rem;
  }
  .goods_batch_pack {
    padding-bottom: 0.15rem;
    margin-bottom: 0.15rem;
    .good_pack {
      margin-top: 0.1rem;
      span {
        display: inline-block;
        padding: 0 0.4rem;
        line-height: 0.6rem;
        background-color: #e6e6e6;
        border-radius: 0.3rem;
        text-align: center;
        margin-right: 0.2rem;
        color: #999;
        letter-spacing: 0.05rem;
        margin-bottom: 0.1rem;
        &.active {
          background: rgba(49, 177, 88, 0.2);
          color: #31b158;
        }
      }
    }
    .good_desc {
      font-size: 0.24rem;
      color: #f3a427;
    }
  }
  .goods_input {
    padding-bottom: 0.2rem;
    .good_input {
      position: relative;
      box-sizing: border-box;
      height: 0.82rem;
      background-color: #f5f5f5;
      border: 0.01rem solid #ccc;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input {
        width: 70%;
        line-height: 0.8rem;
        font-size: 0.34rem;
        text-indent: 0.2rem;
        border-radius: 0.1rem;
        background-color: #f5f5f5;
        box-sizing: border-box;
      }
      span {
        line-height: 0.8rem;
        padding-right: 0.2rem;
      }
    }
  }
  .good_save {
    background-color: #31b158;
    text-align: center;
    line-height: 0.8rem;
    margin-top: 1rem;
    font-size: 0.36rem;
    color: #fff;
    letter-spacing: 0.1rem;
    border-radius: 0.1rem;
    &[disabled] {
      background-color: #b3b3b3;
    }
  }
}
</style>